import { ProjectActions } from '@octopus-do/octopus-project-core'

import { InitialSectionIds } from '../sections'
import { InitialNodeIds } from './initialNodeIds'
import {
  InitialChildNodes,
  InitialRootNode,
  InitialSecondaryNodes,
} from './initialNodes'

export const InitNodesActions = [
  ProjectActions.nodes.add({
    items: [InitialRootNode],
    index: 0,
    parents: [InitialSectionIds.main],
  }),
  ProjectActions.nodes.add({
    items: InitialChildNodes,
    index: 0,
    parents: [InitialNodeIds.main.root],
  }),
  ProjectActions.nodes.add({
    items: InitialSecondaryNodes,
    index: 0,
    parents: [InitialSectionIds.secondary],
  }),
]
